export default __webpack_public_path__ + "static/media/girl-profile1.6474e79f.gif";